import { FC, useCallback, useRef } from "react";
import { Box, Button, Card, CardContent, CardHeader, Grid, Drawer, useMediaQuery } from "@mui/material";
import { useRecordContext } from "ra-core";
import { RecPatch } from "~/dataProvider/tools";
import { ProductReleaseDto, ProductType } from "~/gen/api/user"


const ReleaseView: FC<{
  open: boolean;
  setOpen: (x: boolean) => void;
  productType?: ProductType;
  releaseId?: number;
}> = ({ open, setOpen, productType, releaseId }) => {
  const match = useMediaQuery('(max-width: 880px)')
  const width = match ? 'calc(100vw - 50px)' : 830
  const record = useRecordContext<ProductReleaseDto&RecPatch>()
  const recordRef = useRef<boolean | null>(!!record)
  const handleClose = useCallback(() => { 
    setOpen(false) 
    recordRef.current = null
  }, [setOpen])
  
  return (
    <Drawer
      anchor="right"
      onClose={handleClose}
      open={open}
      PaperProps={{
        sx: {
          p: 2,
          width: width,
        }
      }}
    >
      <Card sx={{ overflowY: 'auto', mb: 4, }}>
        <CardHeader title='Release Note' />
        <CardContent>
          <Grid
            container
            spacing={4}
          >
            <Grid item xs={12} >
              <Box sx={{minHeight: 500}}>
                <Box sx={{'& pre': { whiteSpace:'pre-wrap' }}}>
                  {record?.releaseComment && 
                    <>
                      <div dangerouslySetInnerHTML ={{__html: record?.releaseComment}}></div>
                    </>
                  }
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="outlined"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Box>
      </Card>
    </Drawer>
  )
}

export default ReleaseView;

